import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";

declare var ko: any;

export class logsList_template extends vnTemplate{

    public simpleFilter: filterSimple_template;
    public resultsInfo: resultsInfo_template;
    public pagination: pagination_template;
    public operationFilterDropdown: filterDropdown_template;
    public brandFilterDropdown: filterDropdown_template;

    //
    // implementation of base class [vnTemplate]
    protected getTemplateHtml(): string{

        return  `  
                
                <div class="sub-header w-justify">
                    <div class="w-left">
                        <div>
                            <label class="form-label form-label-box">Brand</label>
                            ` + this.brandFilterDropdown.getHtmlBuild() + `
                        </div>
                        <div>
                            <label class="form-label form-label-box">Operations</label>
                            ` + this.operationFilterDropdown.getHtmlBuild() + `
                        </div>
                    </div>
                </div>                                     
                
                <div class="list-header w-justify">
                    <div class="w-left">
                        <h2 class="section-title">logs</h2>
                    </div>                    
                    <div class="w-center"> 
                        ` + this.simpleFilter.getHtmlBuild() + `
                    </div>
                    <div class="w-right"> 
                        ` + this.pagination.getHtmlBuild() + `
                    </div>
                </div>
                
                <div class="w-list-results content_buckets" data-bind="css: { loading: isLoading }">
                   
                   ` + this.resultsInfo.getHtmlBuild() + `
                   <table class="list-results list-logs" id="list-results">
                        <thead>
                            <input data-bind="value: orderBy" type="hidden">
                            <input data-bind="value: orderByDirection" type="hidden">
                            <tr>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }" class="icon i-dropdown-simple">Id</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateLog') }, css: { 'list-sort-desc': orderByAndDirection()=='dateLog_DESC', 'list-sort-asc': orderByAndDirection()=='dateLog_ASC' }" class="icon i-dropdown-simple">time</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'message') }, css: { 'list-sort-desc': orderByAndDirection()=='message_DESC', 'list-sort-asc': orderByAndDirection()=='message_ASC' }" class="icon i-dropdown-simple">message</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'type') }, css: { 'list-sort-desc': orderByAndDirection()=='type_DESC', 'list-sort-asc': orderByAndDirection()=='type_ASC' }" class="icon i-dropdown-simple">type</span></th>
                                <th class="align-right"><span>See in Full List</span></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: logs">
                           <tr data-bind="attr: {id: 'row-' + $data.id}, css: {'highlight-log-fill-list': $data.highlight}">
                                <td class=""><span data-bind="text: id"></span></td>
                                <td class="no-wrap"><span data-bind="text: dateLog.date"></span></td>
                                <td class="" ><span data-bind="text: message"></span></td>
                                <td class=""><span data-bind="text: type"></span></td>
                                <td class="button align-right"><button data-bind="event: { click: $parent.onClickLogTrack }" type="button" class="btn mini icon only-icon i-back"></button></td>
                            </tr>
                        <tbody>
                    </table>
                </div>
            `;
    }

    //
    // implementation of base class [vnTemplate]
    protected getTemplateName(): string{
        return "logsList_template";
    }

    //
    // implementation of base class [vnTemplate]
    protected getMainElementClasses(): Array<string>{
        return [""];
    }

    //
    // implementation of base class [vnTemplate]
    protected initPartial(): void {

        this.simpleFilter = new filterSimple_template("simpleFilter", this.getTemplateViewModel(), this.caller);
        this.resultsInfo = new resultsInfo_template("resultsInfo", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 35;
        this.operationFilterDropdown = new filterDropdown_template("operationFilterDropdown", this.getTemplateViewModel(), this.caller)
        this.brandFilterDropdown = new filterDropdown_template("brandFilterDropdown", this.getTemplateViewModel(), this.caller)
    }

    //
    // implementation of base class [vnTemplate]
    public buildViewModel(){

        // define the viewModel data/ functions
        let self = this;

        return  {
            orderBy: ko.observable("dateLog"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("time_DESC"),
            pageNumber: ko.observable(1),
            filterKeyword: ko.observable(""),
            isLoading: ko.observable(0),
            logs: ko.observableArray([]),
            automaticTasks: ko.observableArray([]),
            labelName: ko.observable("task executer"),

            // advanced filters
            taskExecuters: ko.observableArray([]),
            selectedTaskExecuterFilter: ko.observable(),
            operation_selected: ko.observable,

            // bulk delete
            options_executeType: ko.observableArray([{name: "Rerun Cron", value:"rerun_cron"},{name: "Rerun Automatic Task", value:"rerun_automatic_task"}]),
            options_executeType_all: ko.observableArray([{name: "Rerun Automatic Task", value:"rerun_automatic_task"}]),
            selected_executeType:ko.observable(),
            selected_automaticTask:ko.observable(),
            selected_executeType_all:ko.observable(),
            displayAutomaticTasks:ko.observable(false),
            trackedLogId: ko.observable(null),
            isHighlightable: ko.observable(0),
            onClickReorder : function(value, data, event){ self.onClickReorder(value, data, event); },
            onClickLogTrack: function (data, event) { self.onClickLogTrack(data.id); }
        };
    }

    public getViewModelForRequest() {
        return {
            pagination: this.getTemplateViewModel().pagination,
            trackedId: this.getTemplateViewModel().trackedLogId(),
            filter:{
                orderBy: this.getTemplateViewModel().orderBy(),
                orderByDirection: this.getTemplateViewModel().orderByDirection()

            },
            filterSimple: this.simpleFilter.getViewModelForRequest(),
            filters: {
                operation_selected: this.getTemplateViewModel().operationFilterDropdown.selectedOption,
                brand_selected: this.getTemplateViewModel().brandFilterDropdown.selectedOption
            },
            bulkAction: {
                selected_executeType: this.getTemplateViewModel().selected_executeType(),
                selected_automaticTask: this.getTemplateViewModel().selected_automaticTask(),
                selected_executeType_all: this.getTemplateViewModel().selected_executeType_all()
            }
        }
    }

    //
    // implementation of base class [vnTemplate]
    public activateLoading(){

        this.getTemplateViewModel().isLoading(1);
    }

    //
    // implementation of base class [vnTemplate]
    public deactivateLoading(){

        this.getTemplateViewModel().isLoading(0);
    }

    //
    // clicks action
    public onClickReorder(value, data, event){

        data.orderBy(value);
        if( data.orderByDirection() == "DESC" ){
            data.orderByDirection("ASC");
        }
        else{
            data.orderByDirection("DESC");
        }
        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.reorderLogs();
    }

    //
    // set data
    public setLogs(logs: Array<any>): void{
        let trackedLogId: number = this.getTemplateViewModel().trackedLogId();
        logs.forEach((log) => {
            log.highlight = (log.id == trackedLogId);
        });
        this.getTemplateViewModel().logs(logs);
    }

    // track specific log and identify its page on the normal list.
    public onClickLogTrack(logId: number): any {

        this.getTemplateViewModel().trackedLogId(logId);
        this.simpleFilter.getTemplateViewModel().filterKeyword("");
        this.getTemplateViewModel().operationFilterDropdown.setSelectedOption("");
        this.getTemplateViewModel().brandFilterDropdown.setSelectedOption("");
        this.caller.getItems();
    }


    public setPageNumber(currentPage: number): void{

        this.pagination.getTemplateViewModel().pageNumber(currentPage);
    }

    public setPagination(totalCount: number): void {

        this.pagination.setNumberItemToPaginate(totalCount);
    }

    public setResultPage(totalCount: number): void {

        let resultsInfoToSet = {
            nbr_results: totalCount,
            nbr_pages: Math.ceil(totalCount / this.getTemplateViewModel().pagination.itemPerPage),
            execution_time: "00,000"
        };

        this.resultsInfo.setResults(resultsInfoToSet);
    }


    public resetTrackedLogId(): void {

        this.getTemplateViewModel().trackedLogId(null);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/logsList_template.ts